module.exports = __webpack_public_path__ + "static/media/3 Train-AP_Z1.2a997112.png";